<template>
<div>
    
    <div class='col-sm-4' v-if="showpassform"> 
        <input type='text' class='form-control' v-model="pass"/>
        <input type='button' class='btn btn-success d-block' value='Ок' @click='sendPass()'/>
        <div class='alert alert-danger' v-if="passerror">Ошибся</div>
    </div>

    <div v-if="showtest">
    <div class="well">
            <strong>При посещении организации обращались ли Вы к информации о ее деятельности, размещенной на информационных стендах в помещениях организации?
            </strong>
            <div class="form-group clearfix">
                <label class="form-control btn btn-info" for="pole_0_0">
                    <input id="pole_0_0" name="pole_0" type="radio" value="0" v-model="checkedNames[0]" />
                    Да
                </label>
                <label class="form-control btn btn-info" for="pole_0_1">
                    <input id="pole_0_1" name="pole_0" type="radio" value="1" v-model="checkedNames[0]" />
                    Нет
                </label>
            </div>
        </div>
        <div class="well" v-if="checkedNames[0]==0">
            <strong>Удовлетворены ли Вы открытостью, полнотой и доступностью информации о деятельности организации, размещенной на информационных стендах в помещении организации?
            </strong>
            <div class="form-group clearfix">
                <label class="form-control btn btn-info" for="pole_1_0">
                    <input id="pole_1_0" name="pole_1" type="radio" value="0" v-model="checkedNames[1]" />
                    Да
                </label>
                <label class="form-control btn btn-info" for="pole_1_1">
                    <input id="pole_1_1" name="pole_1" type="radio" value="1" v-model="checkedNames[1]" />
                    Нет
                </label>
            </div>
        </div>

        <div class="well">
            <strong>Пользовались ли Вы официальным сайтом организации, чтобы получить информацию о ее деятельности?
            </strong>
            <div class="form-group clearfix">
                <label class="form-control btn btn-info" for="pole_2_0">
                    <input id="pole_2_0" name="pole_2" type="radio" value="0" v-model="checkedNames[2]" />
                    Да
                </label>
                <label class="form-control btn btn-info" for="pole_2_1">
                    <input id="pole_2_1" name="pole_2" type="radio" value="1" v-model="checkedNames[2]" />
                    Нет
                </label>
            </div>
        </div>

        <div class="well" v-if="checkedNames[2]==0">
            <strong>Удовлетворены ли Вы открытостью, полнотой и доступностью информации о деятельности организации, размещенной на ее официальном сайте в информационно-телекоммуникационной сети «Интернет»?
            </strong>
            <div class="form-group clearfix">
                <label class="form-control btn btn-info" for="pole_3_0">
                    <input id="pole_3_0" name="pole_3" type="radio" value="0" v-model="checkedNames[3]" />
                    Да
                </label>
                <label class="form-control btn btn-info" for="pole_3_1">
                    <input id="pole_3_1" name="pole_3" type="radio" value="1" v-model="checkedNames[3]" />
                    Нет
                </label>
            </div>
        </div>

        <!--<div class="well">
            <strong>Своевременно ли Вам была предоставлена услуга в организации, в которую Вы обратились (в соответствии со временем записи на прием к специалисту (консультацию), с датой госпитализации (диагностического исследования), со сроками, установленными индивидуальной программой предоставления социальных услуг, и прочее)?  
            </strong>
            <div class="form-group clearfix">
                <label class="form-control btn btn-info" for="pole_4_0">
                    <input id="pole_4_0" name="pole_4" type="radio" value="0" v-model="checkedNames[4]" />
                    Да (услуга предоставлена своевременно или ранее установленного срока)
                </label>
                <label class="form-control btn btn-info" for="pole_4_1">
                    <input id="pole_4_1" name="pole_4" type="radio" value="1" v-model="checkedNames[4]" />
                    Нет (услуга предоставлена с опозданием)
                </label>
            </div>
        </div>
        -->


        <div class="well">
            <strong>Удовлетворены ли Вы комфортностью условий предоставления услуг в организации (наличие комфортной зоны отдыха (ожидания); наличие и понятность навигации в помещении организации; наличие и доступность питьевой воды в помещении организации; наличие и доступность санитарно-гигиенических помещений в организации; удовлетворительное санитарное состояние помещений организации; транспортная доступность организации (наличие общественного транспорта, парковки); доступность записи на получение услуги (по телефону, на официальном сайте организации, посредством Единого портала государственных и муниципальных услуг, при личном посещении в регистратуре или у специалиста организации) и прочие условия)?
            </strong>
            <div class="form-group clearfix">
                <label class="form-control btn btn-info" for="pole_5_0">
                    <input id="pole_5_0" name="pole_5" type="radio" value="0" v-model="checkedNames[5]" />
                    Да
                </label>
                <label class="form-control btn btn-info" for="pole_5_1">
                    <input id="pole_5_1" name="pole_5" type="radio" value="1" v-model="checkedNames[5]" />
                    Нет
                </label>
            </div>
        </div>

    <div class="well">
            <strong>Имеете ли Вы (или лицо, представителем которого Вы являетесь) установленную группу инвалидности?
            </strong>
            <div class="form-group clearfix">
                <label class="form-control btn btn-info" for="pole_6_0">
                    <input id="pole_6_0" name="pole_6" type="radio" value="0" v-model="checkedNames[6]" />
                    Да
                </label>
                <label class="form-control btn btn-info" for="pole_6_1">
                    <input id="pole_6_1" name="pole_6" type="radio" value="1" v-model="checkedNames[6]" />
                    Нет
                </label>
            </div>
        </div>

    <div class="well" v-if="checkedNames[6]==0">
            <strong>Удовлетворены ли Вы доступностью предоставления услуг для инвалидов в организации?
            </strong>
            <div class="form-group clearfix">
                <label class="form-control btn btn-info" for="pole_7_0">
                    <input id="pole_7_0" name="pole_7" type="radio" value="0" v-model="checkedNames[7]" />
                    Да
                </label>
                <label class="form-control btn btn-info" for="pole_7_1">
                    <input id="pole_7_1" name="pole_7" type="radio" value="1" v-model="checkedNames[7]" />
                    Нет
                </label>
            </div>
        </div>

    <div class="well">
            <strong>Удовлетворены ли Вы доброжелательностью и вежливостью работников организации, обеспечивающих первичный контакт с посетителями и информирование об услугах при непосредственном обращении в организацию (работники регистратуры, справочной, приемного отделения, кассы, приемной комиссии и прочие работники)?
            </strong>
            <div class="form-group clearfix">
                <label class="form-control btn btn-info" for="pole_8_0">
                    <input id="pole_8_0" name="pole_8" type="radio" value="0" v-model="checkedNames[8]" />
                    Да
                </label>
                <label class="form-control btn btn-info" for="pole_8_1">
                    <input id="pole_8_1" name="pole_8" type="radio" value="1" v-model="checkedNames[8]" />
                    Нет
                </label>
            </div>
        </div>

    <div class="well">
            <strong>Удовлетворены ли Вы доброжелательностью и вежливостью работников организации, обеспечивающих непосредственное оказание услуги при обращении в организацию (врачи, социальные работники, работники, осуществляющие экспертно-реабилитационную диагностику, преподаватели, тренеры, инструкторы, библиотекари, экскурсоводы и прочие работники)?
            </strong>
            <div class="form-group clearfix">
                <label class="form-control btn btn-info" for="pole_9_0">
                    <input id="pole_9_0" name="pole_9" type="radio" value="0" v-model="checkedNames[9]" />
                    Да
                </label>
                <label class="form-control btn btn-info" for="pole_9_1">
                    <input id="pole_9_1" name="pole_9" type="radio" value="1" v-model="checkedNames[9]" />
                    Нет
                </label>
            </div>
        </div>

    <div class="well">
            <strong>Пользовались ли Вы какими-либо дистанционными способами взаимодействия с организацией (телефон, электронная почта, электронный сервис (форма для подачи электронного обращения (жалобы, предложения), получение консультации по оказываемым услугам), раздел «Часто задаваемые вопросы», анкета для опроса граждан на сайте и прочие.)? 
            </strong>
            <div class="form-group clearfix">
                <label class="form-control btn btn-info" for="pole_10_0">
                    <input id="pole_10_0" name="pole_10" type="radio" value="0" v-model="checkedNames[10]" />
                    Да
                </label>
                <label class="form-control btn btn-info" for="pole_10_1">
                    <input id="pole_10_1" name="pole_10" type="radio" value="1" v-model="checkedNames[10]" />
                    Нет
                </label>
            </div>
        </div>

    <div class="well" v-if="checkedNames[10]==0">
            <strong>Удовлетворены ли Вы доброжелательностью и вежливостью работников организации, с которыми взаимодействовали в дистанционной форме (по телефону, по электронной почте, с помощью электронных сервисов (для подачи электронного обращения (жалобы, предложения), получения консультации по оказываемым услугам) и в прочих дистанционных формах)?
            </strong>
            <div class="form-group clearfix">
                <label class="form-control btn btn-info" for="pole_11_0">
                    <input id="pole_11_0" name="pole_11" type="radio" value="0" v-model="checkedNames[11]" />
                    Да
                </label>
                <label class="form-control btn btn-info" for="pole_11_1">
                    <input id="pole_11_1" name="pole_11" type="radio" value="1" v-model="checkedNames[11]" />
                    Нет
                </label>
            </div>
        </div>
    <div class="well">
            <strong>Готовы ли Вы рекомендовать данную организацию родственникам и знакомым (или могли бы Вы ее рекомендовать, если бы была возможность выбора организации)?
            </strong>
            <div class="form-group clearfix">
                <label class="form-control btn btn-info" for="pole_12_0">
                    <input id="pole_12_0" name="pole_12" type="radio" value="0" v-model="checkedNames[12]" />
                    Да
                </label>
                <label class="form-control btn btn-info" for="pole_12_1">
                    <input id="pole_12_1" name="pole_12" type="radio" value="1" v-model="checkedNames[12]" />
                    Нет
                </label>
            </div>
        </div>
    <div class="well">
            <strong>Удовлетворены ли Вы организационными условиями предоставления услуг (графиком работы организации (подразделения, отдельных специалистов, периодичностью прихода социального работника на дом и прочие); навигацией внутри организации (наличие информационных табличек, указателей, сигнальных табло, инфоматов и прочие)?
            </strong>
            <div class="form-group clearfix">
                <label class="form-control btn btn-info" for="pole_13_0">
                    <input id="pole_13_0" name="pole_13" type="radio" value="0" v-model="checkedNames[13]" />
                    Да
                </label>
                <label class="form-control btn btn-info" for="pole_13_1">
                    <input id="pole_13_1" name="pole_13" type="radio" value="1" v-model="checkedNames[13]" />
                    Нет
                </label>
            </div>
        </div>
    <div class="well">
            <strong>Удовлетворены ли Вы в целом условиями оказания услуг в организации?
            </strong>
            <div class="form-group clearfix">
                <label class="form-control btn btn-info" for="pole_14_0">
                    <input id="pole_14_0" name="pole_14" type="radio" value="0" v-model="checkedNames[14]" />
                    Да
                </label>
                <label class="form-control btn btn-info" for="pole_14_1">
                    <input id="pole_14_1" name="pole_14" type="radio" value="1" v-model="checkedNames[14]" />
                    Нет
                </label>
            </div>
        </div>
    <div class="well">
            <strong>Ваши предложения по улучшению условий оказания услуг в данной организации:
            </strong>
            <div class="form-group clearfix">
                <textarea class='form-control'></textarea>
            </div>
        </div>
    <div class="well">
            <strong>Ваш пол
            </strong>
            <div class="form-group clearfix">
                <label class="form-control btn btn-info" for="pole_15_0">
                    <input id="pole_15_0" name="pole_15" type="radio" value="0" v-model="checkedNames[15]" />
                    Мужской
                </label>
                <label class="form-control btn btn-info" for="pole_15_1">
                    <input id="pole_15_1" name="pole_15" type="radio" value="1" v-model="checkedNames[15]" />
                    Женский
                </label>
            </div>
        </div>
    <div class="well">
            <strong>Ваш возраст (укажите сколько  Вам полных лет)
            </strong>
            <div class="form-group clearfix">
                <input type='text' class='form-control' v-model="checkedNames[16]" />
            </div>
        </div>
        <input type='button' class='btn btn-success' value='Ответить' @click="sendData()" />
    </div>
</div>
</template>


<script>
import axios from 'axios';

export default {
created: function(){
    if(this.$route.query.school != undefined ){
        this.pass = this.$route.query.school;
        this.sendPass()
    }
},
methods:{
    sendPass: function(){
        axios.post('http://eduqa.egechita.ru/back/getanketa', {"pass":this.pass}).then((response) => {
            //console.log(response.data.open);
            if(response.data.open == 1){
                this.num = response.data.num;
                this.showtest = true;
                this.showpassform = false;
            }else{
                this.passerror = true;
            }
        });
    },
    sendData: function(){
        if(this.checkAnkets()){
            axios.post('http://eduqa.egechita.ru/back/saveanketa/'+this.num, this.checkedNames);  
        alert('Спасибо за ответ');
        this.showtest = false;
        this.showpassform = true;
        }
    },
    checkAnkets: function(){
        var checks = [0, 2, 5, 6, 8, 9, 10, 12, 13, 14, 15];
        for(var i in checks){
            if(this.checkedNames[checks[i]] == undefined || this.checkedNames[checks[i]] == null){
                var elem = document.querySelectorAll('label[for="pole_'+checks[i]+'_0"]');
                for (var j = 0; j < elem.length; j++) {
                    elem[j].style.backgroundColor = 'red';
                }
                var elem = document.querySelectorAll('label[for="pole_'+checks[i]+'_1"]');
                for (var j = 0; j < elem.length; j++) {
                    elem[j].style.backgroundColor = 'red';
                }
                return false;
                //elem.style.backgroundColor = 'red';
                //console.log(checks[i]);
            }
        }
        return true;
    }
},
    data(){
        return {
            checkedNames: [],
            pass: "",
            passerror: false,
            num: 0,
            showtest: false,
            showpassform: true
        }
    }
}
</script>